import { render } from "./Discount.vue?vue&type=template&id=bb9e71c6&scoped=true"
import script from "./Discount.vue?vue&type=script&lang=js"
export * from "./Discount.vue?vue&type=script&lang=js"

import "./Discount.vue?vue&type=style&index=0&id=bb9e71c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9e71c6"]])

export default __exports__